// src/app/translate-loader.ts
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '../environments/environment';

/**
 * Função de fábrica utilizada para carregar arquivos de tradução via HTTP.
 * Espera arquivos localizados no caminho: /assets/i18n/{lang}.json
 */
export function createTranslateLoader(http: HttpClient) {
  // Em ambiente local, adiciona um cache-buster para evitar que o browser
  // sirva uma versão antiga do JSON de traduções após alterações.
  const suffix = environment.production ? '.json' : `.json?cb=${Date.now()}`;
  return new TranslateHttpLoader(http, 'assets/i18n/', suffix);
}
